export default "__VITE_ASSET__8XrR_qtM__"